import script from "./CostCalc.vue?vue&type=script&lang=ts&setup=true"
export * from "./CostCalc.vue?vue&type=script&lang=ts&setup=true"

import "./CostCalc.vue?vue&type=style&index=0&id=c8f7b500&lang=scss"

const __exports__ = script;

export default __exports__